<template>
  <div class="w-[1016px]">
    <PayRight
      desc-class="boxShadow"
      content-class="boxShadow"
      :hpp-config="hppConfig"
      :inline="true"
      :rights-type="USER_LEVEL_KEY.TEAM_LIGHT"
      :userInfo="userInfo"
      :headers="{
        Authorization: `token ${starterOrgRes.user_id} ${starterOrgRes.key}`,
      }"
      :behavior="ORDER_BEHAVIOR.BUY"
      :order_type="ORDER_TYPE.PACKAGE"
      :pay-success-update-user="false"
      :on-success-callback="onSuccess"
    />
  </div>
</template>
<script lang="ts" setup>
import { TEAM_CREATE_PROVIDES } from '../../../constant.ts';
import PayRight from '~/features/paymentDesk/components/buy-rights/buy-content/rights-16.vue';
import { USER_LEVEL_KEY } from '~/api/interface/auth';
import { ORDER_BEHAVIOR, ORDER_TYPE, type CreateStarterOrgResponse } from '~/api/interface';

const emit = defineEmits(['next', 'paySuccess']);

const props = defineProps<{
  starterOrgRes: CreateStarterOrgResponse;
}>();

// 团队创建的 provide 注入
provide(TEAM_CREATE_PROVIDES, {
  orderType: ORDER_TYPE.PACKAGE,
  rightsType: USER_LEVEL_KEY.TEAM_LIGHT,
  auth: `token ${props.starterOrgRes.user_id} ${props.starterOrgRes.key}`,
});

const userInfo = computed(() => props.starterOrgRes.account_info);

const hppConfig = {
  success_url: `${location.origin}${location.pathname}?step=3`,
  cancel_url: `${location.origin}${location.pathname}?step=2`,
};

function onSuccess() {
  emit('next'); // 这里用两个事件，是因为next是多个步骤的通用事件
  emit('paySuccess');
}
</script>
<style lang="scss" scoped>
:deep(.boxShadow) {
  box-shadow: 0px -2px 20px 0px rgba(168, 166, 202, 0.2);
}
</style>
